(function () {
  /* =====================================================
     Custom Shopify Cart Drawer
     Purpose:
     - Stop normal Shopify add-to-cart redirect
     - Add products using AJAX
     - Open side cart drawer
     - Allow quantity increase, decrease, and remove
     - Hide footer when cart is empty
     - Show paid products before free gifts
  ===================================================== */

  /* =====================================================
     1. Get drawer elements from custom-cart-drawer.liquid
  ===================================================== */

  const drawer = document.getElementById('CustomCartDrawer');
  const overlay = document.getElementById('CustomCartOverlay');
  const body = document.getElementById('CustomCartDrawerBody');
  const totalEl = document.getElementById('CustomCartDrawerTotal');
  const footer = document.getElementById('CustomCartDrawerFooter');

  /*
    If any important drawer element is missing,
    stop the script so it does not break the website.
  */
  if (!drawer || !overlay || !body || !totalEl || !footer) {
    console.warn('Custom cart drawer missing required elements.');
    return;
  }

  /*
    Prevent double add-to-cart if user clicks the button very fast.
  */
  let isAdding = false;

  /* =====================================================
     2. Shopify route helper
     Supports stores with language or market folders,
     for example /en/cart/add.js instead of /cart/add.js
  ===================================================== */

  function getRouteRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  /* =====================================================
     3A. DYNAMIC DISCOUNT SYNCHRONISATION

     Supported URL parameters:

     ?discount_code=FAM500
     ?promo=FAM500
     ?discount=FAM500

     Recommended:
     ?discount_code=FAM500

     Also supports multiple comma-separated codes:
     ?discount_code=CODE1,CODE2

     IMPORTANT:
     Shopify calculates the actual discount.
     This script does NOT manually subtract money.
  ===================================================== */

  const discountStorageKey =
    'custom_active_discount_codes';

  let discountUpdatePromise = null;
  let lastDiscountAttemptSignature = '';
  let supersededSessionDiscountCodes = [];


  function normalizeDiscountCode(value) {
    const code =
      String(value || '').trim();

    return /^[A-Za-z0-9_-]+$/.test(code)
      ? code
      : '';
  }


  function getUniqueDiscountCodes(values) {
    const uniqueCodes = [];
    const seenCodes = new Set();

    values.forEach(function (value) {
      String(value || '')
        .split(',')
        .forEach(function (part) {
          const code =
            normalizeDiscountCode(part);

          if (!code) {
            return;
          }

          const comparisonCode =
            code.toLowerCase();

          if (
            seenCodes.has(
              comparisonCode
            )
          ) {
            return;
          }

          seenCodes.add(
            comparisonCode
          );

          uniqueCodes.push(code);
        });
    });

    return uniqueCodes;
  }


  function getStoredDiscountCodes() {
    try {
      const storedValue =
        sessionStorage.getItem(
          discountStorageKey
        );

      if (!storedValue) {
        return [];
      }

      const parsedValue =
        JSON.parse(storedValue);

      return Array.isArray(parsedValue)
        ? getUniqueDiscountCodes(
            parsedValue
          )
        : getUniqueDiscountCodes([
            storedValue
          ]);

    } catch (error) {
      return [];
    }
  }


  function storeDiscountCodes(codes) {
    try {
      if (codes.length) {
        sessionStorage.setItem(
          discountStorageKey,
          JSON.stringify(codes)
        );
      } else {
        sessionStorage.removeItem(
          discountStorageKey
        );
      }

    } catch (error) {
      console.warn(
        'Custom cart drawer could not store discount code:',
        error
      );
    }
  }


  function getDiscountCodesFromUrl() {
    const params =
      new URLSearchParams(
        window.location.search
      );

    const possibleValues = [];

    params
      .getAll('discount_code')
      .forEach(function (value) {
        possibleValues.push(value);
      });

    params
      .getAll('promo')
      .forEach(function (value) {
        possibleValues.push(value);
      });

    params
      .getAll('discount')
      .forEach(function (value) {
        possibleValues.push(value);
      });

    return getUniqueDiscountCodes(
      possibleValues
    );
  }


  function captureDiscountCodesFromUrl() {
    const urlDiscountCodes =
      getDiscountCodesFromUrl();

    if (!urlDiscountCodes.length) {
      return;
    }

    const previouslyStoredCodes =
      getStoredDiscountCodes();

    const incomingCodeSet =
      new Set(
        urlDiscountCodes.map(
          function (code) {
            return code.toLowerCase();
          }
        )
      );

    supersededSessionDiscountCodes =
      previouslyStoredCodes.filter(
        function (code) {
          return !incomingCodeSet.has(
            code.toLowerCase()
          );
        }
      );

    storeDiscountCodes(
      urlDiscountCodes
    );

    lastDiscountAttemptSignature = '';

    console.log(
      'Custom cart drawer captured discount:',
      urlDiscountCodes.join(',')
    );
  }


  function getActiveDiscountCodes() {
    const urlDiscountCodes =
      getDiscountCodesFromUrl();

    if (urlDiscountCodes.length) {
      return urlDiscountCodes;
    }

    return getStoredDiscountCodes();
  }


  function getExplicitCartDiscountCodes(
    cart
  ) {
    const codes = [];

    if (
      cart &&
      Array.isArray(
        cart.discount_codes
      )
    ) {
      cart.discount_codes.forEach(
        function (discount) {
          if (
            discount &&
            discount.code
          ) {
            codes.push(
              discount.code
            );
          }
        }
      );
    }


    if (
      cart &&
      Array.isArray(
        cart.cart_level_discount_applications
      )
    ) {
      cart.cart_level_discount_applications
        .forEach(
          function (discount) {
            if (
              discount &&
              discount.code
            ) {
              codes.push(
                discount.code
              );
            }
          }
        );
    }


    if (
      cart &&
      Array.isArray(cart.items)
    ) {
      cart.items.forEach(
        function (item) {

          if (
            Array.isArray(
              item.discounts
            )
          ) {
            item.discounts.forEach(
              function (discount) {
                if (
                  discount &&
                  discount.code
                ) {
                  codes.push(
                    discount.code
                  );
                }
              }
            );
          }


          if (
            Array.isArray(
              item.discount_allocations
            )
          ) {
            item.discount_allocations
              .forEach(
                function (allocation) {

                  const application =
                    allocation
                      ? allocation.discount_application ||
                        allocation.application
                      : null;

                  if (
                    application &&
                    application.code
                  ) {
                    codes.push(
                      application.code
                    );
                  }
                }
              );
          }

        }
      );
    }

    return getUniqueDiscountCodes(
      codes
    );
  }


  function cartContainsAllCodes(
    cart,
    requiredCodes
  ) {
    const cartCodeSet =
      new Set(
        getExplicitCartDiscountCodes(
          cart
        ).map(
          function (code) {
            return code.toLowerCase();
          }
        )
      );

    return requiredCodes.every(
      function (code) {
        return cartCodeSet.has(
          code.toLowerCase()
        );
      }
    );
  }


  function getDiscountAttemptSignature(
    cart,
    codes
  ) {
    const cartLines =
      Array.isArray(cart.items)
        ? cart.items.map(
            function (item) {
              return [
                item.key ||
                  item.variant_id ||
                  item.id ||
                  '',
                Number(
                  item.quantity || 0
                )
              ].join(':');
            }
          )
        : [];

    return [
      codes
        .map(
          function (code) {
            return code.toLowerCase();
          }
        )
        .join(','),

      cartLines.join('|')

    ].join('::');
  }


  async function applyActiveDiscountCodes(
    cart
  ) {

    const activeDiscountCodes =
      getActiveDiscountCodes();

    if (
      !cart ||
      !Array.isArray(cart.items) ||
      !cart.items.length ||
      !activeDiscountCodes.length
    ) {
      return cart;
    }


    if (
      cartContainsAllCodes(
        cart,
        activeDiscountCodes
      )
    ) {
      return cart;
    }


    const attemptSignature =
      getDiscountAttemptSignature(
        cart,
        activeDiscountCodes
      );


    if (
      attemptSignature ===
      lastDiscountAttemptSignature
    ) {
      return cart;
    }


    if (discountUpdatePromise) {
      return discountUpdatePromise;
    }


    const supersededCodeSet =
      new Set(
        supersededSessionDiscountCodes
          .map(
            function (code) {
              return code.toLowerCase();
            }
          )
      );


    const preservedExistingCodes =
      getExplicitCartDiscountCodes(
        cart
      ).filter(
        function (code) {
          return !supersededCodeSet.has(
            code.toLowerCase()
          );
        }
      );


    const codesToSubmit =
      getUniqueDiscountCodes(
        preservedExistingCodes.concat(
          activeDiscountCodes
        )
      );


    lastDiscountAttemptSignature =
      attemptSignature;


    discountUpdatePromise =
      (async function () {

        try {

          console.log(
            'Custom cart drawer applying discount:',
            codesToSubmit.join(',')
          );


          const response =
            await fetch(
              getRouteRoot() +
                'cart/update.js',
              {
                method: 'POST',

                headers: {
                  'Content-Type':
                    'application/json',
                  Accept:
                    'application/json'
                },

                body: JSON.stringify({
                  discount:
                    codesToSubmit.join(',')
                })
              }
            );


          const updatedCart =
            await response.json();


          if (!response.ok) {
            throw new Error(
              updatedCart.description ||
              updatedCart.message ||
              'Unable to apply discount code.'
            );
          }


          console.log(
            'Custom cart drawer discount response:',
            updatedCart
          );


          return updatedCart;


        } catch (error) {

          console.warn(
            'Custom cart drawer discount synchronisation error:',
            error
          );

          return cart;


        } finally {

          discountUpdatePromise = null;

        }

      })();


    return discountUpdatePromise;
  }


  captureDiscountCodesFromUrl();



  /* =====================================================
     3. Money formatter
     Current setting: Singapore Dollar
     Change SGD to MYR if this store is Malaysia.
  ===================================================== */

  function formatMoney(cents) {
    return new Intl.NumberFormat(
      'en-SG',
      {
        style: 'currency',
        currency: 'SGD'
      }
    ).format(
      Number(cents || 0) / 100
    );
  }



  /* =====================================================
     4. Open and close drawer functions
  ===================================================== */

  function openDrawer() {
    drawer.classList.add(
      'is-open'
    );

    overlay.classList.add(
      'is-active'
    );

    document.body.classList.add(
      'custom-cart-open'
    );

    drawer.setAttribute(
      'aria-hidden',
      'false'
    );
  }


  function closeDrawer() {
    drawer.classList.remove(
      'is-open'
    );

    overlay.classList.remove(
      'is-active'
    );

    document.body.classList.remove(
      'custom-cart-open'
    );

    drawer.setAttribute(
      'aria-hidden',
      'true'
    );
  }



  /* =====================================================
     5. Fetch current cart from Shopify
     Shopify AJAX cart endpoint:
     /cart.js
  ===================================================== */

  async function getCart() {
    const response = await fetch(
      getRouteRoot() +
        'cart.js?t=' +
        Date.now(),
      {
        headers: {
          Accept: 'application/json'
        },

        cache: 'no-store'
      }
    );

    /*
      Added safeguard:
      Stop rendering if Shopify cannot return a valid cart response.
    */
    if (!response.ok) {
      throw new Error(
        'Unable to load Shopify cart.'
      );
    }

    const cart =
      await response.json();

    /*
      Added discount synchronisation:
      Apply the captured Shopify discount before rendering the drawer.
      Shopify still validates eligibility, expiry and combinations.
    */
    return applyActiveDiscountCodes(
      cart
    );
  }



  /* =====================================================
     6. Change item quantity
     Shopify AJAX cart endpoint:
     /cart/change.js

     quantity 0 = remove item
     quantity 1 or more = update item quantity
  ===================================================== */

  async function changeItem(
    line,
    quantity
  ) {
    const response = await fetch(
      getRouteRoot() +
        'cart/change.js',
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',
          Accept:
            'application/json'
        },

        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      }
    );

    const cart =
      await response.json();

    /*
      Added safeguard:
      Surface Shopify's actual error when a cart update fails.
    */
    if (!response.ok) {
      throw new Error(
        cart.description ||
        cart.message ||
        'Unable to update cart.'
      );
    }

    /*
      Cart content changed, so allow Shopify to re-check the active
      discount code against the updated quantities/products.
    */
    lastDiscountAttemptSignature = '';

    return applyActiveDiscountCodes(
      cart
    );
  }



  /* =====================================================
     7. Update cart count in header
     This targets common Shopify cart count selectors.
     Add your theme's specific cart count class here if needed.
  ===================================================== */

  function updateCartCount(cart) {
    const cartCountEls =
      document.querySelectorAll(
        '.cart-count-bubble span, ' +
        '[data-cart-count], ' +
        '.cart-count, ' +
        '.header__cart-count'
      );

    cartCountEls.forEach(
      function (el) {
        el.textContent =
          cart.item_count;

        /*
          Added cart-count visibility handling:
          Hide the badge when the cart is empty and show it otherwise.
        */
        if (
          cart.item_count > 0
        ) {
          el.classList.remove(
            'hidden'
          );
        } else {
          el.classList.add(
            'hidden'
          );
        }
      }
    );
  }



  /* =====================================================
     8. Detect BOGOS free gifts

     BOGOS can report both the original and final price as S$0.00.
     Therefore, any cart line with a final line price of zero is
     treated as a free gift for display-order purposes only.

     IMPORTANT:
     - This does not add or remove gifts.
     - This does not change eligibility, prices, discounts or totals.
     - This only places paid products before free gifts in the drawer.
  ===================================================== */

  function isFreeGift(item) {
    return Number(
      item.final_line_price || 0
    ) === 0;
  }



  /* =====================================================
     9. Prepare visual cart sequence

     Shopify cart actions rely on the original cart line number.
     Save that line number before rearranging items visually so
     quantity and remove controls continue targeting correctly.
  ===================================================== */

  function getDisplayLines(cart) {
    const originalCartLines =
      cart.items.map(
        function (item, index) {
          return {
            item: item,
            originalLine:
              index + 1
          };
        }
      );

    const paidProductLines =
      originalCartLines.filter(
        function (cartLine) {
          return !isFreeGift(
            cartLine.item
          );
        }
      );

    const freeGiftLines =
      originalCartLines.filter(
        function (cartLine) {
          return isFreeGift(
            cartLine.item
          );
        }
      );

    return paidProductLines.concat(
      freeGiftLines
    );
  }



  /* =====================================================
     10. Escape text before inserting it into drawer HTML
  ===================================================== */

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }



  /* =====================================================
     11. Render cart drawer content
     This controls what appears inside the side cart.
  ===================================================== */

  function renderCart(cart) {
    /*
      Update total price and cart count every time cart changes.
    */
    totalEl.textContent =
      formatMoney(
        cart.total_price
      );

    updateCartCount(cart);

    /*
      Added product-page synchronisation:
      Notify other product-page modules whenever the latest cart
      data is available, including final and original line prices.
    */
    window.dispatchEvent(
      new CustomEvent(
        'custom-cart:updated',
        {
          detail: {
            cart: cart
          }
        }
      )
    );

    /*
      Empty cart state:
      - Hide footer
      - Hide checkout button
      - Hide view cart link
      - Show custom empty message
    */
    if (!cart.items.length) {
      drawer.classList.add(
        'custom-cart-drawer--empty'
      );

      footer.style.display =
        'none';

      body.innerHTML = `
        <div class="custom-cart-drawer__empty-state">
          <h3>
            We are looking for your products, but it looks like your cart is empty...
          </h3>

          <p>
            Click on continue shopping and check out our catalog.
          </p>

          <button
            type="button"
            class="custom-cart-drawer__continue"
            data-cart-close
          >
            Continue shopping
          </button>
        </div>
      `;

      return;
    }

    /*
      Cart has products:
      - Show footer
      - Show checkout button
      - Show view cart link
      - Render product rows
    */
    drawer.classList.remove(
      'custom-cart-drawer--empty'
    );

    footer.style.display = '';

    /*
      Added BOGOS display ordering:
      Paid products are shown first and zero-priced gifts below them.
    */
    const displayLines =
      getDisplayLines(cart);

    body.innerHTML =
      displayLines.map(
        function (cartLine) {

          const item =
            cartLine.item;

          const originalLine =
            cartLine.originalLine;

          const freeGift =
            isFreeGift(item);

          /*
            Product image.
            If no image exists, it will show empty space instead of breaking.
          */
          const image =
            item.image
              ? `
                <img
                  src="${escapeHtml(item.image)}"
                  alt="${escapeHtml(item.product_title)}"
                >
              `
              : '';

          /*
            Variant title.
            Hide "Default Title" because it looks unnecessary to customers.
          */
          const variant =
            item.variant_title &&
            item.variant_title !==
              'Default Title'

              ? `
                <p class="custom-cart-drawer__variant">
                  ${escapeHtml(item.variant_title)}
                </p>
              `

              : '';

          /*
            Each item keeps its original Shopify cart line number.
            Shopify line numbers start from 1, not 0.
          */
          return `
            <div
              class="custom-cart-drawer__item"
              data-line="${originalLine}"
              data-free-gift="${freeGift ? 'true' : 'false'}"
            >
              <div class="custom-cart-drawer__image">
                ${image}
              </div>

              <div>
                <p class="custom-cart-drawer__title">
                  ${escapeHtml(item.product_title)}
                </p>

                ${variant}

                <div class="custom-cart-drawer__price">
                  <span class="custom-cart-drawer__price-current${freeGift ? ' custom-cart-drawer__price-current--free' : ''}">
                    ${
                      freeGift
                        ? 'FREE'
                        : formatMoney(
                            item.final_line_price
                          )
                    }
                  </span>

                  ${
                    Number(
                      item.original_line_price
                    ) >
                    Number(
                      item.final_line_price
                    )

                      ? `
                        <span class="custom-cart-drawer__price-compare">
                          ${formatMoney(item.original_line_price)}
                        </span>
                      `

                      : ''
                  }
                </div>

                ${
                  freeGift
                    ? `
                      <div
                        class="ecot-sg-freegift-status"
                        aria-label="Free gift quantity"
                      >
                        <span class="ecot-sg-freegift-status__qty">
                          ${item.quantity}x
                        </span>

                        <span class="ecot-sg-freegift-status__label">
                          ${
                            item.quantity === 1
                              ? 'Free Gift Added'
                              : 'Free Gifts Added'
                          }
                        </span>
                      </div>
                    `
                    : `
                      <div class="custom-cart-drawer__controls">
                        <button
                          type="button"
                          class="custom-cart-drawer__qty-btn"
                          data-cart-minus
                          aria-label="Decrease quantity"
                        >
                          −
                        </button>

                        <span class="custom-cart-drawer__qty">
                          ${item.quantity}
                        </span>

                        <button
                          type="button"
                          class="custom-cart-drawer__qty-btn"
                          data-cart-plus
                          aria-label="Increase quantity"
                        >
                          +
                        </button>
                      </div>
                    `
                }
              </div>

              ${
                freeGift
                  ? ''
                  : `
                    <button
                      type="button"
                      class="custom-cart-drawer__remove"
                      data-cart-remove
                      aria-label="Remove item"
                    >
                      <span aria-hidden="true">
                        ×
                      </span>
                    </button>
                  `
              }
            </div>
          `;
        }
      ).join('');
  }



  /* =====================================================
     12. Refresh cart
     Gets latest cart data from Shopify, then re-renders drawer.
  ===================================================== */

  async function refreshCart() {
    const cart =
      await getCart();

    renderCart(cart);

    return cart;
  }



  /* =====================================================
     13. AJAX add to cart
     This replaces the normal redirect to /cart.
  ===================================================== */

  async function addToCart(form) {
    /*
      Stop duplicate adds.
    */
    if (isAdding) {
      return;
    }

    isAdding = true;

    try {
      const formData =
        new FormData(form);

      /*
        Add product to Shopify cart using AJAX.
      */
      const response =
        await fetch(
          getRouteRoot() +
            'cart/add.js',
          {
            method: 'POST',
            body: formData,

            headers: {
              Accept:
                'application/json'
            }
          }
        );

      /*
        Show Shopify error if product cannot be added.
        Example: sold out, missing variant, unavailable quantity.
      */
      if (!response.ok) {
        const error =
          await response.json();

        alert(
          error.description ||
          error.message ||
          'Unable to add product to cart.'
        );

        return;
      }

      /*
        After product is added:
        - Refresh drawer content
        - Open side cart
      */
      lastDiscountAttemptSignature = '';

      await refreshCart();

      openDrawer();

      /*
        Added BOGOS delayed refreshes:
        BOGOS may insert free gifts after the paid product. These
        follow-up refreshes make the gifts appear without reloading.
      */
      window.setTimeout(
        function () {
          lastDiscountAttemptSignature = '';

          refreshCart().catch(
            function (error) {
              console.error(
                'Custom cart drawer BOGOS refresh error:',
                error
              );
            }
          );
        },
        500
      );

      window.setTimeout(
        function () {
          lastDiscountAttemptSignature = '';

          refreshCart().catch(
            function (error) {
              console.error(
                'Custom cart drawer delayed BOGOS refresh error:',
                error
              );
            }
          );
        },
        1200
      );

      window.setTimeout(
        function () {
          lastDiscountAttemptSignature = '';

          refreshCart().catch(
            function (error) {
              console.error(
                'Custom cart drawer final BOGOS refresh error:',
                error
              );
            }
          );
        },
        2200
      );

    } catch (error) {
      console.error(
        'Custom cart drawer add-to-cart error:',
        error
      );

    } finally {
      isAdding = false;
    }
  }



  /* =====================================================
     14. Check whether a form is Shopify add-to-cart form
  ===================================================== */

  function isCartAddForm(form) {
    return (
      form &&
      form.action &&
      form.action.includes(
        '/cart/add'
      )
    );
  }



  /* =====================================================
     15. Stop normal form submission
     This prevents Shopify redirecting to cart page.
  ===================================================== */

  document.addEventListener(
    'submit',

    function (event) {
      const form =
        event.target;

      if (!isCartAddForm(form)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      addToCart(form);
    },

    true
  );



  /* =====================================================
     16. Extra click handler for add-to-cart buttons
     Some themes trigger cart redirect from button click,
     before the form submit happens.
  ===================================================== */

  document.addEventListener(
    'click',

    function (event) {
      const button =
        event.target.closest(
          'button[type="submit"], ' +
          'input[type="submit"], ' +
          '[name="add"], ' +
          '.product-form__submit, ' +
          '.add-to-cart'
        );

      if (!button) {
        return;
      }

      const form =
        button.closest('form');

      if (!isCartAddForm(form)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      addToCart(form);
    },

    true
  );



  /* =====================================================
     17. Quantity and remove button actions inside drawer
     - Plus increases quantity
     - Minus decreases quantity
     - Remove sets quantity to 0
  ===================================================== */

  body.addEventListener(
    'click',

    async function (event) {
      const item =
        event.target.closest(
          '.custom-cart-drawer__item'
        );

      if (!item) {
        return;
      }

      /*
        Free gifts are controlled automatically by BOGOS.
        Customers cannot change quantity or remove them manually.
      */
      if (
        item.dataset.freeGift ===
        'true'
      ) {
        return;
      }

      const line =
        Number(
          item.dataset.line
        );

      const qtyEl =
        item.querySelector(
          '.custom-cart-drawer__qty'
        );

      if (!line || !qtyEl) {
        return;
      }

      const currentQty =
        Number(
          qtyEl.textContent || 0
        );

      /*
        Added update safeguards:
        Preserve the original line number and recover cleanly if
        Shopify rejects a quantity or remove request.
      */
      try {

        /*
          Increase quantity.
        */
        if (
          event.target.closest(
            '[data-cart-plus]'
          )
        ) {
          const cart =
            await changeItem(
              line,
              currentQty + 1
            );

          renderCart(cart);

          return;
        }

        /*
          Decrease quantity.
          If quantity reaches 0, Shopify removes the item.
        */
        if (
          event.target.closest(
            '[data-cart-minus]'
          )
        ) {
          const cart =
            await changeItem(
              line,
              Math.max(
                currentQty - 1,
                0
              )
            );

          renderCart(cart);

          return;
        }

        /*
          Remove item completely.
        */
        if (
          event.target.closest(
            '[data-cart-remove]'
          )
        ) {
          const cart =
            await changeItem(
              line,
              0
            );

          renderCart(cart);
        }

      } catch (error) {
        console.error(
          'Custom cart drawer item update error:',
          error
        );

        alert(
          error.message ||
          'Unable to update the cart.'
        );

        refreshCart().catch(
          function (refreshError) {
            console.error(
              'Custom cart drawer recovery error:',
              refreshError
            );
          }
        );
      }
    }
  );



  /* =====================================================
     18. Close drawer actions
     - Header close button
     - Overlay click
     - Empty cart Continue shopping button
  ===================================================== */

  document.addEventListener(
    'click',

    function (event) {

      if (
        event.target.matches(
          '.custom-cart-drawer__close'
        ) ||
        event.target.matches(
          '#CustomCartOverlay'
        ) ||
        event.target.matches(
          '[data-cart-close]'
        )
      ) {
        closeDrawer();
      }

      /*
        Open drawer when customer clicks cart icon/link,
        instead of going directly to /cart.
      */
      const cartLink =
        event.target.closest(
          'a[href="/cart"], ' +
          'a[href^="/cart?"], ' +
          'a[data-panel="cart"]'
        );

      if (
        cartLink &&
        !cartLink.classList.contains(
          'custom-cart-drawer__view-cart'
        )
      ) {
        event.preventDefault();

        /*
          Added compatibility and error handling for themes that
          open the cart through a data-panel attribute.
        */
        lastDiscountAttemptSignature = '';

        refreshCart()
          .then(openDrawer)
          .catch(
            function (error) {
              console.error(
                'Custom cart drawer open error:',
                error
              );
            }
          );
      }
    }
  );



  /* =====================================================
     19. Close drawer with Escape key
  ===================================================== */

  document.addEventListener(
    'keydown',

    function (event) {
      if (
        event.key === 'Escape'
      ) {
        closeDrawer();
      }
    }
  );



  /* =====================================================
     20. Listen for common cart update events

     Added compatibility for theme/app cart changes and browser
     back-forward restoration. Each event reloads the latest cart.
  ===================================================== */

  document.addEventListener(
    'cart:updated',

    function () {
      lastDiscountAttemptSignature = '';

      refreshCart().catch(
        function (error) {
          console.error(
            'Custom cart drawer cart update error:',
            error
          );
        }
      );
    }
  );


  document.addEventListener(
    'cart:refresh',

    function () {
      lastDiscountAttemptSignature = '';

      refreshCart().catch(
        function (error) {
          console.error(
            'Custom cart drawer cart refresh error:',
            error
          );
        }
      );
    }
  );


  window.addEventListener(
    'pageshow',

    function () {
      /*
        Re-capture because the URL may have changed after navigation.
      */
      captureDiscountCodesFromUrl();

      lastDiscountAttemptSignature = '';

      refreshCart().catch(
        function (error) {
          console.error(
            'Custom cart drawer page refresh error:',
            error
          );
        }
      );
    }
  );



  /* =====================================================
     21. Initial cart load
     When page loads, fetch cart data so drawer is ready.
  ===================================================== */

  refreshCart().catch(
    function (error) {
      console.error(
        'Custom cart drawer initial load error:',
        error
      );
    }
  );

})();